export default __webpack_public_path__ + "static/money-fc5589bac8697601442a3ffa5ec590a7.webp";